export * from './getPartnerResponsibles'
export * from './getPartnerResponsibles.types'
